import React from 'react';
import { motion } from 'framer-motion';
import './index.scss';

const Loader = ({ text = "Loading..." }) => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    const loaderVariants = {
        hidden: { rotate: 0 },
        visible: { rotate: 360, transition: { duration: 1, repeat: Infinity, ease: 'linear' } },
    };

    return (
        <motion.div
            className="loader-container"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80vh',
                flexDirection: 'column'
            }}
        >
            <div className="loader"></div>
            <div>
                <p className='d-block'>
                    <i>{text}</i>
                </p>
            </div>
        </motion.div>
    );
};

export default Loader;
